import Select from 'component/atom/forms/select/select/Select';
import React from 'react';
import Wrapper from '../wrapper/Wrapper';
import Toggle from 'component/atom/forms/toggle/Toggle';
import styles from './Auth.module.scss';
const AuthUser = () => {
  return (
    <Wrapper grid>
      <div className={styles['auth-cont']}>
        <span className={styles['auth-by']}>Authenticated By:</span>
        <span className={styles['name']}>System</span>
      </div>
    </Wrapper>
  );
};

export default AuthUser;
